import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {UserProvider} from "./contexts/UserContext";
import {OrderProvider} from "./contexts/OrderContext-delete";
import {LanguageProvider} from './contexts/LanguageContext';
import {ItemProvider} from './contexts/ItemsContext';


const rootElement = document.getElementById('root');
ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <LanguageProvider>
            <UserProvider>
                <ItemProvider>
                    {/*<ShiftProvider>*/}
                    <OrderProvider>
                        <App/>
                    </OrderProvider>
                    {/*</ShiftProvider>*/}
                </ItemProvider>
            </UserProvider>
        </LanguageProvider>
    </React.StrictMode>
);
